import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TopBar from "./Components/TopBar";
import Navbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import Benefits from "./Components/Benefits";
import Features from "./Components/Features";
import FloatingButton from "./Components/FloatingButton";
import Footer from "./Components/Footer";

import Login from "./Pages/Login";
import AdminDashboard from "./Pages/AdminDashboard";
import ChatBooking from "./Pages/ChatBooking";
import HelperInfo from "./Pages/HelperInfo";
import HelperRegister from "./Pages/HelperRegister";   // 🔥 ADDED

/* Simple Temporary Dashboards */
function UserDashboard() {
  return (
    <div className="min-h-screen flex items-center justify-center text-3xl font-bold">
      User Dashboard
    </div>
  );
}

function HelperDashboard() {
  return (
    <div className="min-h-screen flex items-center justify-center text-3xl font-bold">
      Helper Dashboard
    </div>
  );
}

function Home() {
  return (
    <>
      <TopBar />
      <Hero />
      <Benefits />
      <Features />
      <FloatingButton />
    </>
  );
}

function App() {
  return (
    <Router>

      {/* Navbar Always Visible */}
      <Navbar />

      <Routes>

        {/* Home Page */}
        <Route path="/" element={<Home />} />

      
        <Route path="/login" element={<Login />} />

        {/* Dashboards */}
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/helper-dashboard" element={<HelperDashboard />} />

        {/* Chat */}
        <Route path="/chat-booking" element={<ChatBooking />} />

        {/* For Helpers Page */}
        <Route path="/for-helpers" element={<HelperInfo />} />

        {/* 🔥 REGISTER HELPER ROUTE ADDED */}
        <Route path="/register-helper" element={<HelperRegister />} />

      </Routes>

      {/* Footer Always Visible */}
      <Footer />

    </Router>
  );
}

export default App;
